import {PathUtility} from 'src/shared/constants/PathBuilder';
import type {PersonnelViewType} from 'src/shared/constants/ViewTypes';
import type {PersonnelIndexViewType} from 'src/shared/constants/ViewTypes';
import {BaseRouteService} from './BaseRouteService';
import type {ViewModeType} from './IRouteService';

export class PersonnelRouteService extends BaseRouteService {
  constructor(
    enableGoHome: boolean,
    mode: ViewModeType,
    parameters: {[key: string]: any}
  ) {
    super(enableGoHome, mode, parameters);
  }

  isGoHomeEnabled(): boolean {
    return this.enableGoHome;
  }

  getCreateRoute(): string {
    return PathUtility.PersonnelCreate();
  }

  getEditRoute(id: string | number): string {
    const view: PersonnelViewType = this.parameters['view'] || 'overview';
    const fromTab: PersonnelIndexViewType = this.parameters['fromTab'] || 'employee';
    return `${PathUtility.PersonnelEdit(id, view)}?from=${fromTab}`;
  }

  getViewRoute(id: string | number): string {
    const view: PersonnelViewType = this.parameters['view'] || 'overview';
    const fromTab: PersonnelIndexViewType = this.parameters['fromTab'] || 'employee';
    return `${PathUtility.PersonnelView(id, view)}?from=${fromTab}`;
  }

  getGoBackRoute(id?: string | number): string {
    switch (this.mode) {
      case 'create':
      case 'view':
        return this.getGoHomeRoute();

      case 'edit':
        return this.getViewRoute(id!);

      default:
        return '';
    }
  }

  getGoHomeRoute(): string {
    const fromTab: PersonnelIndexViewType = this.parameters['fromTab'] || 'employee';
    return PathUtility.Personnel(fromTab);
  }
}
